import { SubscriptionLevel } from '../lib/api';

interface UserBadgeProps {
  // user_level removed - see #785
  subscription_level?: SubscriptionLevel | null;
  size?: 'xs' | 'sm';
  className?: string;
}

/**
 * UserBadge - Currently disabled, returns null
 *
 * TODO: Re-enable when badge design is finalized
 * Future: May use subscription_level or user_affiliation for badges
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function UserBadge(_props: UserBadgeProps) {
  return null;
}